import { useState } from "react";

import { GridContainer } from "@/components/ui-v2/FilePicker/components/FilePickerContent/components/GridContainer/GridContainer";
import { useFilePickerState } from "@/components/ui-v2/FilePicker/state";

import { usePoserStore } from "../../../../state";
import { PoseMenuState } from "../../../../types";
import { PoseActionsMenu } from "../PoseActionsMenu/PoseActionsMenu";
import { PoseTile } from "../PoseTile/PoseTile";
import { examplePoses, Pose } from "./pose-data";

export const LibraryPoses = () => {
  const { openPoseCreatorInReferencePoseMode } = usePoserStore();
  const { setSelectedFile, selectedFiles, setSelectionAsConfirmed } =
    useFilePickerState();
  const [poseMenuState, setPoseMenuState] = useState<PoseMenuState>({
    anchor: null,
    pose: null,
  });

  const handlePoseSelect = (pose: Pose) => () => {
    setSelectedFile({
      id: pose.id,
      src: pose.url,
      name: pose.name,
      type: "pose",
      contentType: "image/png",
      thumbnailSrc: pose.thumbnailUrl,
      interactedAt: new Date(),
      source: "pose",
    });
  };

  const handlePoseDoubleClick = (pose: Pose, selected: boolean) => () => {
    if (!selected) {
      handlePoseSelect(pose)();
    }

    setSelectionAsConfirmed();
  };

  const handlePoseMenuOpen = (pose: Pose) => (event: React.MouseEvent) => {
    const { x = 0, y = 0 } =
      (event?.target as HTMLElement)?.getBoundingClientRect() || {};
    setPoseMenuState({
      pose: {
        id: pose.id,
        modelUrl: pose.modelUrl,
        viewData: pose.poseData,
      },
      anchor: {
        x: event.clientX || x,
        y: event.clientY || y,
      },
    });
  };

  const handlePoseMenuClose = () => {
    setPoseMenuState({
      pose: null,
      anchor: null,
    });
  };

  const handleDuplicate = () => {
    if (poseMenuState.pose) {
      openPoseCreatorInReferencePoseMode(poseMenuState.pose);
    }
    handlePoseMenuClose();
  };

  return (
    <>
      <GridContainer>
        {examplePoses.map((pose) => {
          const isSelected = selectedFiles.some((file) => file.id === pose.id);

          return (
            <PoseTile
              key={pose.id}
              id={pose.id}
              name={pose.name}
              openPoseImageUrl={pose.thumbnailUrl}
              showcaseImageUrl={pose.showcaseImageUrl}
              selected={isSelected}
              onClick={handlePoseSelect(pose)}
              onDoubleClick={handlePoseDoubleClick(pose, isSelected)}
              onMenuOpen={handlePoseMenuOpen(pose)}
            />
          );
        })}
      </GridContainer>
      {poseMenuState.anchor && (
        <PoseActionsMenu
          open={!!poseMenuState.anchor}
          anchor={poseMenuState.anchor}
          onClose={handlePoseMenuClose}
          onDuplicate={handleDuplicate}
        />
      )}
    </>
  );
};
